export default __webpack_public_path__ + "static/media/lowFiPrototypeWeb.7c350a82.jpg";